import React, {useState,useRef,useEffect} from 'react'
import './TreeView.css'
import icon from '../icons.svg' 

function TreeItems({Data,Level,currFolder,Prev_next,hClick,hDragDrop,ids='',isActive=true}){
    const targetRef = useRef()

    if(!currFolder) currFolder={id:null,name:''}

    const setFocus=(el)=>{
        if(!isActive) return
        if (!el) return
        if (document.activeElement.nodeName==='INPUT') return
        const ut=document.getElementById('ut')
        if(ut&&ut.contains(document.activeElement)){
            const el_rect=el.getBoundingClientRect()
            const top=window.scrollY
            const bottom=top+document.documentElement.clientHeight
            if(el_rect.top>bottom) el.scrollIntoView()
            else if(el_rect.bottom<top) el.scrollIntoView()
            return
        }
        el.focus()
    }

    const allovDrop=(e)=>{
        e.preventDefault();
    }

    const dragEnter=(e)=>{
        if(e.target.className==='cont') e.target.parentNode.style.border='1px solid #929292'
    }

    const dragLeave=(e)=>{
        if(e.target.className==='cont') e.target.parentNode.style.border='none'
    }

    const dragDrop=(e,targ)=>{
        if(e.target.className==='cont') e.target.parentNode.style.border='none'
        let trg={...targ}
        delete trg.isGroup
        delete trg.data
        let itm=JSON.parse(e.dataTransfer.getData('item'))
        hDragDrop(itm,trg)
    }

    const items=Data.map((el,idx)=>{
        let cls=''
        if(Prev_next.neednext){
            Prev_next.neednext=false
            if(!Prev_next.next) Prev_next.next={...el}
        } else if(currFolder&&currFolder.id===el.parent.id&&idx===0){
            Prev_next.topnext={...Prev_next.next}
            Prev_next.next={...el}
        } else if(currFolder&&currFolder.id===el.id&&idx===0){
            //cls=' selected'
            Prev_next.neednext=true
            Prev_next.prev={...el.parent}
        } else if(currFolder&&currFolder.id===el.id){
            //cls=' selected'
            Prev_next.neednext=true
            Prev_next.prev={...Prev_next.curr}
            if(currFolder.parent) Prev_next.up={...el.parent}
        } else if(el.isGroup){
            if(el.data.findIndex(it=>currFolder&&it.id===currFolder.id)===el.data.length-1) Prev_next.neednext=true
        }

        if(currFolder&&currFolder.id===el.id) cls=' selected'

        Prev_next.curr={...el}
        if (el.isGroup) return <TreeGroup key={el.id} Child={el} Level={Level} currFolder={currFolder} Prev_next={Prev_next} hClick={hClick} hDragDrop={hDragDrop} ids={ids} isActive={isActive}/>
        else if(currFolder.id===el.id) return <div key={el.id} ref={elm=>{setFocus(elm);return targetRef}}  tabIndex='0' className={'item'+cls} 
            style={{marginLeft:Level*20+'px'}} onDragOver={allovDrop} onDragEnter={dragEnter} onDragLeave={dragLeave} onDrop={(e)=>dragDrop(e,el)}
            ><div className='folder'><img src={icon+'#catFolderC'+(el.marked==='1'?'Del':'')} alt={''} /></div><div className='cont' key={el.id} onKeyUp={(e)=>{if(e.key === 'Enter') hClick(el)}} onClick={()=>{hClick(el)}}>{el.name}</div></div>
        else return <div key={el.id} tabIndex='0' className={'item'+cls} 
            style={{marginLeft:Level*20+'px'}} onDragOver={allovDrop} onDragEnter={dragEnter} onDragLeave={dragLeave} onDrop={(e)=>dragDrop(e,el)}
            ><div className='folder'><img src={icon+'#catFolderC'+(el.marked==='1'?'Del':'')} alt={''} /></div><div className='cont' key={el.id} onKeyUp={(e)=>{if(e.key === 'Enter') hClick(el)}} onClick={()=>{hClick(el)}}>{el.name}</div></div>
    })
    return <>
        {items}
    </>
}

function TreeGroup({Child,Level,currFolder,Prev_next,hClick,hDragDrop,ids='',isActive=true}){
    let currOp=Level===0?true:false
    if(ids.length>1){
        let p=ids.search('-'+Child.id+'-')
        if(p!==-1) currOp=true
    }
    const [opened, setOpen] = useState(currOp);
    const cls=currFolder&&currFolder.id===Child.id?' selected':''
    const targetRef = useRef()

    const setFocus=(el)=>{
        if(!isActive) return
        if (!el) return
        if (document.activeElement.nodeName==='INPUT') return
        const ut=document.getElementById('ut')
        if(ut&&ut.contains(document.activeElement)){
            const el_rect=el.getBoundingClientRect()
            const top=window.scrollY
            const bottom=top+document.documentElement.clientHeight
            if(el_rect.top>bottom) el.scrollIntoView()
            else if(el_rect.bottom<top) el.scrollIntoView()
            return
        }
        el.focus()
    }

    const allovDrop=(e)=>{
        e.preventDefault();
    }

    const dragEnter=(e)=>{
        if(e.target.className==='cont') e.target.parentNode.style.border='1px solid #929292'
    }

    const dragLeave=(e)=>{
        if(e.target.className==='cont') e.target.parentNode.style.border='none'
    }

    const dragDrop=(e,targ)=>{
        const item=e.dataTransfer.getData('item')
        if(!item) return
        if(e.target.className==='cont') e.target.parentNode.style.border='none'
        let trg={...targ}
        delete trg.isGroup
        delete trg.data
        let itm=JSON.parse(item)
        hDragDrop(itm,trg)
    }

    useEffect(() => {
        let currOp=opened
        if(ids.length>1){
            let p=ids.search('-'+Child.id+'-')
            if(p!==-1) currOp=true
        }
        if(opened!==currOp) setOpen(currOp)
        // eslint-disable-next-line 
    },[ids])

    const keyClick=(e)=>{

        if(e.key==='ArrowLeft'&&opened) setOpen(false)
        else if(e.key==='ArrowRight'&&!opened) setOpen(true)
        //else if(e.key==="Enter") firstItem()
        //else keyHandle(e.key)
    }
    if(!opened){
        if(currFolder&&currFolder.id===Child.id) return <div key={Child.id} ref={elm=>{setFocus(elm);return targetRef}} onKeyUp={keyClick} tabIndex='0' className={'item'+cls} style={{marginLeft:Level*20+'px'}} 
            onDragOver={allovDrop} onDragEnter={dragEnter} onDragLeave={dragLeave} onDrop={(e)=>dragDrop(e,Child)}
            ><div className='folder' onClick={()=>{setOpen(true)}}><img src={icon+'#catFolderF'+(Child.marked==='1'?'Del':'')} alt={''} /></div><div className='cont' key={Child.id} onKeyUp={(e)=>{if(e.key === 'Enter') hClick(Child)}} onClick={()=>{hClick(Child)}}>{Child.name}</div></div>
        else return <div key={Child.id} onKeyUp={keyClick} tabIndex='0' className={'item'+cls} style={{marginLeft:Level*20+'px'}}
            onDragOver={allovDrop} onDragEnter={dragEnter} onDragLeave={dragLeave} onDrop={(e)=>dragDrop(e,Child)}
            ><div className='folder' onClick={()=>{setOpen(true)}}><img src={icon+'#catFolderF'+(Child.marked==='1'?'Del':'')} alt={''} /></div><div className='cont' key={Child.id} onKeyUp={(e)=>{if(e.key === 'Enter') hClick(Child)}} onClick={()=>{hClick(Child)}}>{Child.name}</div></div>
    } else if(currFolder&&currFolder.id===Child.id){
        return <><div key={Child.id} ref={elm=>{setFocus(elm);return targetRef}} onKeyUp={keyClick} tabIndex='0' className={'item'+cls} style={{marginLeft:Level*20+'px'}}
            onDragOver={allovDrop} onDragEnter={dragEnter} onDragLeave={dragLeave} onDrop={(e)=>dragDrop(e,Child)}
            ><div className='folder' onClick={()=>{setOpen(false)}}><img src={icon+'#catFolderO'+(Child.marked==='1'?'Del':'')} alt={''} /></div><div className='cont' key={Child.id} onKeyUp={(e)=>{if(e.key === 'Enter') hClick(Child)}} onClick={()=>{hClick(Child)}}>{Child.name}</div></div>
        <TreeItems Data={Child.data} Level={Level+1} currFolder={currFolder} Prev_next={Prev_next} hClick={hClick} hDragDrop={hDragDrop} ids={ids} isActive={isActive}/></>
    } else {
        return <><div key={Child.id} onKeyUp={keyClick} tabIndex='0' className={'item'+cls} style={{marginLeft:Level*20+'px'}}
            onDragOver={allovDrop} onDragEnter={dragEnter} onDragLeave={dragLeave} onDrop={(e)=>dragDrop(e,Child)}
            ><div className='folder' onClick={()=>{setOpen(false)}}><img src={icon+'#catFolderO'+(Child.marked==='1'?'Del':'')} alt={''} /></div><div className='cont' key={Child.id} onKeyUp={(e)=>{if(e.key === 'Enter') hClick(Child)}} onClick={()=>{hClick(Child)}}>{Child.name}</div></div>
        <TreeItems Data={Child.data} Level={Level+1} currFolder={currFolder} Prev_next={Prev_next} hClick={hClick} hDragDrop={hDragDrop} ids={ids} isActive={isActive}/></>
    }

}

function TreeView({TreeData,Caption,currFolder,hClick,hDragDrop,isActive=true}){
    if(!hClick) hClick=()=>{}
    if(!hDragDrop) hDragDrop=()=>{}
    let d=[...TreeData]
    const getChild=(id)=>{
        let n=d.filter(el=>el.parent&&el.parent.id===id)
        if(!n.length) return false
        for(let i=0;i<n.length;i++){
            let ch=getChild(n[i].id)
            if(ch) n[i]={...n[i],isGroup:true,data:ch}
        }
        return n
    }
    const getParent=(obj)=>{
        let res=''
        if(!obj) return res
        if(obj.parent) res='-'+obj.parent.id+'-'+getParent(obj.parent)
        return res
    }

    const keyClick=(e,prev_next)=>{
        if(e.key==='ArrowUp') {if(prev_next.prev) hClick(prev_next.prev)}
        else if(e.key==='ArrowDown') {if(prev_next.next) hClick(prev_next.next)}
        else if(e.key==='ArrowLeft') {if(prev_next.up) hClick(prev_next.up)}
        //else if(e.key==="Enter") firstItem()
        //else keyHandle(e.key)
    }

    let ids=getParent(currFolder)

    let data=[{id:null,name:Caption,parent:{id:null}}]
    let chld=getChild(null)
    if(chld) {data[0].isGroup=true;data[0].data=chld}
    let prev_next={prev:null,next:null,up:null}
    const items=<TreeItems Data={data} Level={0} currFolder={currFolder} Prev_next={prev_next} hClick={hClick} hDragDrop={hDragDrop} ids={ids} isActive={isActive}/>
    return <div className='treeview' onKeyUp={(e)=>keyClick(e,prev_next)}>
        {items}
    </div>
}
export default TreeView